import $ from "jquery";

$(".cinf__payment-overlay").click(function(e) {
  const chockbox = $(this).siblings(".checkobox");
  chockbox.prop("checked", true);

  if ($(chockbox).is(":checked")) {
    const parent = $(this).parent(".cinf__payment-item");
    parent.toggleClass("cinf__payment-item--active");
    const siblings = parent.siblings(".cinf__payment-item");

    if ($(siblings).hasClass("cinf__payment-item--active")) {
      $(siblings).removeClass("cinf__payment-item--active");
    }
    /*     if ($(siblings).hasClass("cinf__payment-item--active")) {
    $(this)removeClass(".cinf__payment-item--active"));
    } */
  } else {
  }
});

$(".cinf__payment-item .checkobox").change(function() {
  if ($(this).is(":checked")) {
    $(".cinf__payment-item").addClass("menuitemshow");
  } else {
    $(".cinf__payment-item").removeClass("menuitemshow");
  }
});

$("#radioDeliverBlik").change(function() {
  if ($(this).is(":checked")) {
    $("div.menuitem").addClass("menuitemshow");
  }
});

$(".cartCheckout #unlockButton").click(function() {
  $(this).toggleClass("unlocked");
  $(".data .box").toggleClass("box--unlocked");

  if ($(this).hasClass("unlocked")) {
    $(this)
      .find(".button")
      .html("Zapisz <span></span><span></span><span></span><span></span>");
  } else {
    $(this)
      .find(".button")
      .html("Zmień <span></span><span></span><span></span><span></span>");
  }

  const input = $(".cartSummary__table input");
  $(input).toggleClass("unlocked");
  $(input).prop("disabled", function(i, v) {
    return !v;
  });

  /*   if (input.prop("disabled", true)) {
  } else {
    $(this).text("test");
  } */
  /*   if (input.prop("disabled", false)) {
    $(input).prop("disabled", true);
    console.log("unlock");
  } */
});
